/* eslint-disable react/jsx-no-target-blank */
import * as React from 'react';

import { ImageNone } from '@cian/image-none-component';

import { getDeletedDateString } from '../../utils/favoriteEntity';
import { Text } from '../Text';
import { trackImageLinkClick } from './trackings';

import * as styles from './MainImage.css';
import { IPageState } from '../../types/page';
import { TUser } from '../../api';
import { IFavoriteEntity } from '../../types/results';

export interface IMainImageStoreProps {
  page: IPageState;
  user: TUser;
  total: number;
  favoriteEntities: IFavoriteEntity[];
}

export interface IMainImageOwnProps {
  favoriteEntity: IFavoriteEntity;
}

export type TMainImage = IMainImageStoreProps & IMainImageOwnProps;

export function MainImage(props: TMainImage) {
  const {
    favoriteEntity: { fullUrl, photoFullUrl, status, deleteDate, entityId },
    favoriteEntities,
    page,
    user,
    total,
  } = props;

  return (
    <div className={styles['container']}>
      <a
        href={fullUrl}
        target="_blank"
        onClick={() => {
          trackImageLinkClick(page, user, entityId, favoriteEntities, total);
        }}
      >
        {photoFullUrl ? <img src={photoFullUrl} /> : <ImageNone />}
      </a>
      {status && status !== 'published' && (
        <div className={styles['overlay']}>
          <div className={styles['text']}>
            <Text bold={true}>
              Объявление
              <br />
              снято с публикации
            </Text>
            {deleteDate && (
              <Text textSize="small" color="black">
                Объявление в избранном
                <br />
                хранится 90 дней,
                <br />и будет удалено {getDeletedDateString(deleteDate)}
              </Text>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
